import { postRequest, patchRequest, deleteRequest } from "@react/helpers/fetch"

export const createInstallment = (invoiceId, body) =>
  postRequest({ url: `/invoices/${invoiceId}/installments.json`, body })

export const updateInstallment = (invoiceId, id, body) =>
  patchRequest({ url: `/invoices/${invoiceId}/installments/${id}.json`, body })

export const destroyInstallment = (invoiceId, id) =>
  deleteRequest(`/invoices/${invoiceId}/installments/${id}.json`)

export const generateDefaultInstallments = (invoiceId, body) =>
  postRequest({ url: `/invoices/${invoiceId}/installments/generate_default.json`, body })

export const recordPayment = (invoiceId, id, body) =>
  postRequest({ url: `/invoices/${invoiceId}/installments/${id}/record_payment.json`, body })

export const sendReminder = (invoiceId, id, body = {}) =>
  postRequest({ url: `/invoices/${invoiceId}/installments/${id}/send_reminder.json`, body })

export const matchBankTransaction = (invoiceId, id, body) =>
  postRequest({ url: `/invoices/${invoiceId}/installments/${id}/match_bank_transaction.json`, body })
